import React from "react";
import { Menu, Dropdown, Avatar } from "antd";
import { connect } from 'react-redux'
import {
    SettingOutlined,
    LogoutOutlined
} from '@ant-design/icons';

import { signOut } from 'redux/actions/Auth';

const NavProfile = ({signOut, user}) => {
    const profileImg = "https://image.flaticon.com/icons/svg/3135/3135715.svg";
    const profileMenu = (
        <div className="nav-profile nav-dropdown">
            <div className="nav-profile-header">
                <div className="d-flex">
                    <Avatar size={45} src={profileImg} />
                    <div className="pl-3">
                        <h4 className="mb-0">{user.displayName}</h4>
                        <span className="text-muted">{user?.email?.substring(0,20)}...</span>
                    </div>
                </div>
            </div>
            <div className="nav-profile-body">
                <Menu>
                    <Menu.Item key={1} onClick={e => signOut()}>
            <span>
              <LogoutOutlined className="mr-3"/>
              <span className="font-weight-normal">Cerrar sesión</span>
            </span>
                    </Menu.Item>
                </Menu>
            </div>
        </div>
    );
    return (
        <Dropdown placement="bottomRight" overlay={profileMenu} trigger={["click"]}>
            <Menu className="d-flex align-item-center" mode="horizontal">
                <Menu.Item>
                    <SettingOutlined className="nav-icon mr-0" />
                </Menu.Item>
            </Menu>
        </Dropdown>
    );
}
const mapStateToProps = ({ auth }) => {
    return {
        user: auth.user,
    };
};
export default connect(mapStateToProps, {signOut})(NavProfile)
